<template>
  <div>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getAll"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getAll"
      :editDepartment="selectedDepartment"
    ></Edit>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>

    <v-container>
      <SearchBar class="mt-2 mx-4" v-model="search" :hideBackBtn="true" />
      <div>{{ count }} Departments</div>
      <v-row class="pb-3 mr-3" align-content="center" justify="space-between">
       <v-spacer></v-spacer>
        <v-col cols="2" class="text-right">
          <v-btn rounded small dark @click="createDepartment" color="primary">New</v-btn>
        </v-col>
      </v-row>
      <v-list two-line class="touch-view-container">
        <template v-for="(item, index) in departments">
          <v-list-item :key="index">
            <v-list-item-content>
              <v-list-item-title v-text="item.name" class="text-capitalize"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click.stop.prevent="editDepartment(item)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click.stop.prevent="deleteDepartment(item)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>

          <v-divider inset v-if="index < departments.length - 1" :key="index + 100"></v-divider>
        </template>
      </v-list>
    </v-container>
  </div>
</template>

<script>
import departmentService from "../service";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "department-list",
  data() {
    return {
      search: null,
      departments: [],
      createDialog: false,
      editDialog: false,
      selectedDepartment: null,
      count: 0,
      limit: 50,
      offset: 0,
      loading: false,
      rowsPerPageItems: [10, 25, 50, 100],
      pagination: {
        rowsPerPage: 10,
        sortBy: "name",
      },
    };
  },
  async created() {
    this.getAll();
  },
  watch: {
    search() {
      if (this.search.length > 3 || this.search.length === 0) {
        this.getAll();
      }
    },
  },
  components: {
    Create,
    Edit,
  },
  methods: {
    createDepartment() {
      this.createDialog = !this.createDialog;
    },
    getAll() {
      this.loading = true;
      return departmentService
        .getAll(
          {
            limit: this.limit,
            offset: this.offset,
            noPagination: true,
            search: this.search,
            orderBy: [this.pagination.sortBy],
          },
        )
        .then(async (response) => {
          const departments = response.data;
          this.departments = departments.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          this.count = response.count;
          this.loading = false;
          return response;
        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
    deleteDepartment(department) {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            departmentService.delete(department.id).then((response) => {
              if (response.data) {
                this.$toast.success("Department has been deleted", {
                  timeout: 2000,
                });

                this.getAll();
              }
            });
          }
        })
        .catch((error) => {
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });
        });
    },
    editDepartment(department) {
      if (department) {
        this.selectedDepartment = department;
        this.editDialog = !this.editDialog;
      } else {
        return alert("Id Not Found");
      }
    },
  },
};
</script>

<style scoped>
.touch-view-container {
  height: calc(100vh - 260px);
  width: 100%;
  overflow: auto;
}
</style>
